var map = {
	"./dev.config.json": 179,
	"./prod.config.json": 180,
	"./qa.config.json": 181,
	"./stg.config.json": 182
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 178;


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/.*\.config\.json$
// module id = 178
// module chunks = 0